module.exports = __webpack_public_path__ + "img/payment-with-card.6a57217d.svg";